// KEEP_IN_SYNC weavy/core/src/shared/enums/weave-surface.enum.ts
export enum WeaveSurface {
  FIGMA_EMBED = 'figma_embed',
  STANDALONE = 'standalone',
}
